module.exports = __webpack_public_path__ + "static/img/nms-desk.7410d655.png";